import React, { memo } from 'react';
import styled from 'styled-components';
import theme from 'theme/theme';
import Skeleton from '../../components/Skeleton';
import Repeat from '../../components/Repeat';

const Wrapper = styled.div`
  padding: 15px 15px 15px 25px;
  @media (min-width: ${theme.breakpoints.desktop}) {
    padding-left: 30px;
  }
`;

const MenuSkeleton = () => (
  <Repeat
    times={5}
    render={(i) => (
      <Wrapper key={i}>
        <Skeleton
          key={i}
          width="18px"
          height="18px"
          borderRadius="50px"
          heightRandomness={0}
          widthRandomness={0}
          color={theme.colors.medium}
          style={{ margin: '0 20px -2px 0' }}
        />
        <Skeleton
          height="12px"
          width="70%"
          color={theme.colors.medium}
        />
      </Wrapper>
    )}
  />
);

export default memo(MenuSkeleton);
